module.exports = __webpack_public_path__ + "img/img5.73db434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img5.png
// module id = QeSs
// module chunks = 2